import { ScrewCompressorAnimatic } from '@crossnokaye/ux-animatics';

import {
  ANIMATIC_PRIMARY_LABEL,
  ANIMATIC_SECONDARY_LABEL,
} from '@/features/equipment-browser/animatics/constants';
import { getLabel } from '@/features/equipment-browser/animatics/helpers';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticScrewCompressor = ({
  config,
  labels,
  state,
  className,
}: AnimaticConfigProps) => {
  const isTrim = config.specificAnimaticConfig?.screwCompressor?.isTrim ?? false;
  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);
  const secondaryLabel = getLabel(labels, ANIMATIC_SECONDARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={0.9} scaleY={0.9}>
      <ScrewCompressorAnimatic
        isService={false}
        isTrim={isTrim}
        metricLabel={primaryLabel?.text}
        state={state}
        typeLabel={secondaryLabel?.text}
      />
    </ScaledAnimatic>
  );
};
